import React, { Component } from 'react'
import { withCookies, Cookies } from 'react-cookie'
import { Route, NavLink, Link, Redirect, Switch, BrowserRouter as Router } from 'react-router-dom'
import './ContractListPage.scss'
import ContractList from '../../Components/Contract/ContractList'
import ContractDetail from '../../Components/Contract/ContractDetail'
import BillList from '../../Components/Contract/BillList'
import BillDetail from '../../Components/Contract/BillDetail'
import HeaderMenu from '../../Components/Commons/HeaderMenu'
import ReactGA from 'react-ga'
import MetaTags from 'react-meta-tags'

const active = {
    color: '#000000',
    borderBottom: '3px solid #2E655B',
}

class BudgetListPage extends Component {
    render() {
        return (
            <div>
                <MetaTags>
                    <title>
                        투명한 집짓기 하우스플래너 - 하우스플래너에서는 우리집 예산이 어떻게 사용되는지 투명하게
                        공개합니다 .
                    </title>
                </MetaTags>
                <HeaderMenu />
                <div className="section_wrap section_wrap_menu">
                    <div className="budgets_list_wrap">
                        <Router>
                            <div>
                                <ul
                                    className={
                                        this.props.cookies.get('noti_length') &&
                                        this.props.cookies.get('noti_length') !== '0' &&
                                        this.props.cookies.get('project_role') === '건축주' &&
                                        this.props.cookies.get('noti_hide') !== this.props.cookies.get('project')
                                            ? 'top_navi top_navi_low'
                                            : 'top_navi'
                                    }>
                                    {/* <NavLink
                                        to={`${this.props.match.url}/dashboard`}
                                        activeStyle={active}
                                        onClick={() => {
                                            ReactGA.event({
                                                category: '예산관리',
                                                label: '탭 메뉴',
                                                action: '현황 클릭',
                                            })
                                        }}>
                                        현황
                                    </NavLink> */}
                                    <NavLink
                                        to={`${this.props.match.url}/contracts`}
                                        activeStyle={active}
                                        onClick={() => {
                                            ReactGA.event({
                                                category: '예산관리',
                                                label: '탭 메뉴',
                                                action: '계약 메뉴 클릭',
                                            })
                                        }}>
                                        계약서 목록
                                    </NavLink>
                                    <NavLink
                                        to={`${this.props.match.url}/bills`}
                                        activeStyle={active}
                                        onClick={() => {
                                            ReactGA.event({
                                                category: '예산관리',
                                                label: '탭 메뉴',
                                                action: '청구서 클릭',
                                            })
                                        }}>
                                        청구서 목록
                                    </NavLink>
                                </ul>
                                <Switch>
                                    <Route exact path={`${this.props.match.url}/bills`} component={BillList} />
                                    <Route exact path={`${this.props.match.url}/bills/:id`} component={BillDetail} />
                                </Switch>
                                <Switch>
                                    <Route exact path={`${this.props.match.url}/contracts`} component={ContractList} />
                                    <Route
                                        exact
                                        path={`${this.props.match.url}/contracts/:id`}
                                        component={ContractDetail}
                                    />
                                </Switch>
                            </div>
                        </Router>
                    </div>
                </div>
            </div>
        )
    }
}

export default withCookies(BudgetListPage)



// WEBPACK FOOTER //
// ./Src/Containers/Contract/ContractListPage.js